@mixin centrar {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
}

@mixin alt-font {
    font-size: var(--avatar-alt-text-font-size);
    color: var(--color-text1);
    text-shadow: 0 0 2px rgba(255, 255, 255, 0.8);
}

:host {
    --avatar-alt-text-font-size: 15px;
    --avatar-border-radius: 50%;
    // --width: 40px;
    // --height: 40px;
    width: var(--width, 40px);
    height: var(--height, 40px);
    display: inline-block;
    border-radius: var(--avatar-border-radius);
    box-sizing: border-box;

    * {
        box-sizing: border-box;
    }

    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
        border-radius: inherit;
        overflow: hidden;
        position: relative;

        .avatar {
            display: flex;
            width: 100%;
            height: 100%;
            border-radius: var(--avatar-border-radius);
            object-fit: cover;

            &.error {
                opacity: 0;
            }
        }

        .default-icon {
            // @include centrar;
            width: 100%;
            height: 100%;

            >* {
                width: 100%;
                height: 100%;
            }
        }

        .status-indicator {
            @include centrar;
            background-color: var(--color-info);
            border-radius: 50%;
            padding: 1px;
        }

        .alt-text-short {
            @include centrar;
            @include alt-font;
            font-weight: 700;
        }
    }

    &.circle {
        border-radius: 50%;
    }

    &.rounded {
        border-radius: 12px;
    }

    &.square {
        border-radius: 0;
    }
}

::slotted([slot="k_alt"]) {
    @include centrar;
    @include alt-font;
}